// Cloud price types are only set on cloud agreements.
const priceTypes = {
	CUSTOM: "custom",
	EDIT: "edit",
	PROOF: "proof",
	EXTRA: "extra",
	RECORD: "record",
	MANAGE: "manage",
	READER: "reader",
	PRODUCTION: "production",
	CLOUD_START_FEE_AUDIO: "cloudStartFeeAudio",
	CLOUD_START_FEE_EBOOK: "cloudStartFeeEbook",
	CLOUD_REVENUE_LIVE: "cloudRevenueLive",
	CLOUD_REVENUE_INACTIVE: "cloudRevenueInactive",
};

export const cloudPriceTypes = [
	priceTypes.CLOUD_START_FEE_AUDIO,
	priceTypes.CLOUD_START_FEE_EBOOK,
	priceTypes.CLOUD_REVENUE_LIVE,
	priceTypes.CLOUD_REVENUE_INACTIVE,
];

export default priceTypes;
